import { render, staticRenderFns } from "./UploadedAds.vue?vue&type=template&id=6256b77d&scoped=true&"
import script from "./UploadedAds.vue?vue&type=script&lang=js&"
export * from "./UploadedAds.vue?vue&type=script&lang=js&"
import style0 from "./UploadedAds.vue?vue&type=style&index=0&id=6256b77d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6256b77d",
  null
  
)

export default component.exports